import { render, staticRenderFns } from "./Literature.vue?vue&type=template&id=6b11733e&scoped=true"
import script from "./Literature.vue?vue&type=script&lang=js"
export * from "./Literature.vue?vue&type=script&lang=js"
import style0 from "./Literature.vue?vue&type=style&index=0&id=6b11733e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b11733e",
  null
  
)

export default component.exports